import { Project, User } from "konect-model";
import { SideNavSettings } from "../view/Settings";

export default class LocalStorageService {

    static getCollapsedTasksList() : string[] {
        const collapsedTasksList = localStorage.getItem("collapsedTasksList");
        return collapsedTasksList ? JSON.parse(collapsedTasksList) : [];
    }

    static setCollapsedTasksList(collapsedTasksList : string[]) {
        localStorage.setItem("collapsedTasksList", JSON.stringify(collapsedTasksList));
    }
    
    static getMinimizeLeaves() : boolean {
        const minimizeLeaves = localStorage.getItem("minimizeLeaves");
        return minimizeLeaves === "true" ? true : false;
    }

    static setMinimizeLeaves(minimizeLeaves : boolean) {
        localStorage.setItem("minimizeLeaves", minimizeLeaves + "");
    }

    static getShowConstraintArrows() : boolean {
        const showConstraintArrows = localStorage.getItem("showConstraintArrows");
        return showConstraintArrows === "true" ? true : false;
    }

    static setShowConstraintArrows(showConstraintArrows : boolean) {
        localStorage.setItem("showConstraintArrows", showConstraintArrows + "");
    }
    
    static getProjectIdToResumeOnReload() : string {
        const latestProject = localStorage.getItem("latestProject");
        return latestProject ? latestProject : "";
    }

    static setProjectIdToResumeOnReload(id : string) {
        localStorage.setItem("latestProject", id);
    }

    static setOfflineMode(isOffline : boolean) {
        localStorage.setItem("offlineMode", isOffline + "");
    }

    static getOfflineMode() : boolean {
        const offlineMode = localStorage.getItem("offlineMode");
        return offlineMode === "true";
    }
    static getSidenavSettings() : SideNavSettings {
        const settings = this.getStorageObject("sidenavSettings");
        if (!settings.isStatic) {
            return {
                isStatic: false,
                showGraph: true,
                showIdeabox: true,
                tableGlyphSketching: false,
                hideGlyphs: true
            }
        }
        // Ensure hideGlyphs has a default value for existing settings
        if (settings.hideGlyphs === undefined) {
            settings.hideGlyphs = true;
        }
        return settings
    } 

    static setSidenavSettings(settings : SideNavSettings) {
        this.setStorageObject("sidenavSettings", settings);
    }

    static getUser() {
		let user = new User();
		Object.assign(user, this.getStorageObject("user"))
		return user;
	}

    public static getOfflineProjects() : Project[] {
        const projects = this.getStorageObject("projects") || [];
        return Array.isArray(projects) ? projects : [];
    }

    public static saveOfflineProject(project : Project) {
        const projects = this.getOfflineProjects();
        const index = projects.findIndex(p => p.id === project.id);
        if (index >= 0) {
            projects[index] = project;
        } else {
            projects.push(project);
        }
        this.setStorageObject("projects", projects);
    }

    public static deleteOfflineProject(project : Project) {
        const projects = this.getOfflineProjects();
        const newProjects = projects.filter(p => p.id !== project.id);
        this.setStorageObject("projects", newProjects);
    }

    private static getStorageObject(key: string) { 
        const string = localStorage.getItem(key);
        if (!string) {
            return {}
        }
        const obj = JSON.parse(string);
        if (!obj) {
            return {}
        }
        return obj;
    }

    private static setStorageObject(key: string, obj: Object) {
        if (!key) {
            return;
        }
        localStorage.setItem(key, JSON.stringify(obj))
    }
}